export default __webpack_public_path__ + "static/media/pencil.6628cace.svg";